<template>
  <div class="ezukit-player" :style="containerStyles">
    <!-- 播放器容器 -->
    <div :id="playerId" ref="playWind" class="player-container"/>
    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      正在加载播放器...
    </div>
    <!-- 错误提示 -->
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
  
export default {
  name: 'EZUIKitPlayer',
  
  props: {
    // 视频流地址（EZOPEN协议）
    url: {
      type: String,
      required: true
    },
    // 访问令牌
    accessToken: {
      type: String,
      required: true
    },
    // 模板样式
    template: {
      type: String,
      default: 'simple'
    },
    // 播放器唯一ID
    playerId: {
      type: String,
      default: () => `player-${Math.random().toString(36).substr(2, 9)}`
    },
    // 是否自动播放
    autoplay: {
      type: Boolean,
      default: true
    },
    // 右侧宽度
    rightWidth: {
      type: Number,
      default: 500
    }
  },
  
  data() {
    return {
      player: null,
      loading: false,
      error: null,
      EZOPENDemo: null,
      containerSize: { width: 500, height: 310 }
    }
  },
  
  computed: {
    containerStyles() {
      return {
        width: '100%',
        height: '100%',
        position: 'relative'
      }
    }
  },
  
  mounted() {
    // 延迟初始化，确保容器尺寸已计算
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.playWind && this.$refs.playWind.offsetParent !== null) {
          this.initPlayer();
        } else {
          console.warn('容器尚未准备好，延迟初始化...');
          setTimeout(() => this.initPlayer(), 500);
        }
      }, 100);
    });
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  
  beforeDestroy() {
    this.destroyPlayer();
    window.removeEventListener('resize', this.handleResize);
  },
  
  methods: {

    // 获取容器的实际尺寸
    getContainerSize() {
      return {
        width: (this.rightWidth-20)/2,
        height: (((this.rightWidth-20)/2)*9)/16
      };
    },
    
    // 初始化播放器
    async initPlayer() {
      try {
        this.loading = true;
        this.error = null;
        
        // 检查EZUIKit是否已加载
        if (typeof window.EZUIKit === 'undefined') {
          await this.loadEZUIKitScript();
        }
        
        // 确保DOM已渲染
        await this.$nextTick();
        
        // 获取容器的实际尺寸
        const size = this.getContainerSize();
        this.containerSize = size;
        
        console.log(`初始化播放器，尺寸: ${size.width}x${size.height}`);
        
        // 初始化播放器
        this.player = new window.EZUIKit.EZUIKitPlayer({
          id: this.playerId,
          width: size.width,
          height: size.height,
          template: this.template,
          url: this.url,
          accessToken: this.accessToken,
          autoplay: this.autoplay,
          handleError: function(err) {
              console.log('Error:', err);
          }
        })
        
        this.EZOPENDemo = this.player;
        this.$emit('ready', this.player);
        this.loading = false;
        
        // 延迟调整大小，确保播放器完全初始化
        setTimeout(() => {
          this.adjustPlayerSize();
        }, 500);
        
      } catch (err) {
        console.error('EZUIKit初始化失败:', err);
        this.error = '播放器初始化失败: ' + err.message;
        this.loading = false;
        this.$emit('error', err);
      }
    },
    
    // 调整播放器大小
    adjustPlayerSize() {
      if (!this.player || !this.$refs.playWind) return;
      
      const size = this.getContainerSize();
      if (size.width <= 0 || size.height <= 0) return;
      
      // 更新容器尺寸
      this.containerSize = size;
      
      // 如果播放器有resize方法，调用它
      if (typeof this.player.resize === 'function') {
        this.player.resize(size.width, size.height);
      }
      
      // 强制重新渲染
      this.$forceUpdate();
    },
    
    // 动态加载EZUIKit脚本
    loadEZUIKitScript() {
      return new Promise((resolve, reject) => {
        // 检查是否已存在脚本
        if (document.querySelector('script[src*="ezuikit"]')) {
          const checkInterval = setInterval(() => {
            if (typeof window.EZUIKit !== 'undefined') {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          return;
        }
        
        const script = document.createElement('script');
        script.src = 'https://res-more.deebike.com/other/ezuikit0816.js';
        script.onload = () => {
          const checkInterval = setInterval(() => {
            if (typeof window.EZUIKit !== 'undefined') {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
        }
        script.onerror = (err) => {
          reject(new Error('加载EZUIKit脚本失败'));
        }
        document.head.appendChild(script);
      })
    },
    
    // 处理窗口大小变化
    handleResize() {
      // 防抖处理
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.adjustPlayerSize();
      }, 200);
    },
    
  }
}
</script>